import React, { useState, useEffect } from 'react';
import { AiFillStar } from 'react-icons/ai';
import { MdOutlineRemoveShoppingCart } from 'react-icons/md';
import Header from './Header';
import { useLocation,useNavigate } from 'react-router-dom';
import { AiOutlineArrowLeft} from "react-icons/ai";

const CartPage = () => {
  const location = useLocation();
  const initialData = location.state;
  const [data, setData] = useState(initialData);
  const [products, setProducts] = useState([]);
  const [cost, setCost] = useState(0);
  const navigate = useNavigate();

  const handleNavigation = (path) => {
    // const items = { cart: props.cart };
    navigate(`/${path}`, { state: data });
  }

  // const productPage = (id) => {
  //   // console.log('cart',cart)
  //   navigate(`/ProductDisplay`, { state: [id, data] }, );
  // }

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch('https://dummyjson.com/products');
        const items = await response.json();
        setProducts(items.products);
        let newCost = 0;
        items.products.forEach((product) => {
          if (data.includes(product.id)) {
            // console.log(product.price);
            newCost += product.price;
          }
        });
        setCost(newCost);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
  
    fetchData();
  }, [data]);
  
  

  const removeItem = (id) => {
    const updatedData = data.filter((itemId) => itemId !== id);
    setData(updatedData);
  };

  return (
    <>
      <Header cart={data} />
<div className='mt-2 ms-2 products italic'>
  <button onClick={()=>handleNavigation('homepage')} className='flex justify-center items-center align-middle gap-1 text-xs italic uppercase'><AiOutlineArrowLeft/>Back to Home</button>
</div>

      <div className='products flex flex-wrap items-center justify-center align-bottom gap-3 mt-4 animate-rotate-x'>
      <span className='uppercase italic text-sm'>Total Cost:</span> <span className='text-xl font-bold'>${cost}</span>
      {/* Rest of your code */}
    </div>
    <hr className='flex flex-wrap items-center justify-center mx-80 sm:mx-3 mt-4' ></hr>

      <div className="products flex flex-wrap items-center justify-center gap-12 sm:gap-3 mt-6  animate-rotate-x">
        {products.map((product, index) => {
          if (data.includes(product.id)) {
            return (
              <div className=" animate-delay-0">
              <div
                key={product.id}
                className=" rounded translate-y-0 hover:-translate-y-4 sm:hover:-translate-y-4 ease-in-out duration-300  my-3 sm:mb-2 p-2 flex flex-col justify-center bg-white  border"
              >
                <div 
                  className=" rounded w-44 sm:w-40 h-32 animate-fade-right animate-delay-0 sm:h-28 bg-cover bg-center "
                  style={{ backgroundImage: `url(${product.thumbnail})` }}
                ></div>

                <div className="font-normal italic mt-2 text-blue-950 sm:text-sm tracking-tight  truncate sm:w-40 animate-delay-200 animate-fade-right ">
                  {product.title}
                </div>
                <div className="inline-block  justify-start align-bottom animate-fade-right animate-delay-500">
                  <span className="text-xl  sm:text-xl font-semibold tracking-tighter text-gray-950 ">
                    ${product.price}
                  </span>
                  <span className="italic text-xs ms-2 text-red-950/80 ">
                    
                    <span className="text-sm sm:text-xs text-red-1200 line-through">
                      ${product.discountPercentage} OFF
                    </span>
                  </span>
                </div>
                <div className="flex flex-row items-start justify-between align-middle">
                  <span className="italic text-xs flex flex-row align-middle items-center animate-fade-right animate-delay-700">
                    <AiFillStar className="text-yellow-500" />
                    {product.rating}
                  </span>
                  <span className="flex flex-row text-xs border px-3 italic text-gray-400 border-gray-400">
                    ONLY {product.stock} LEFT
                  </span>
                </div>
                <div className="w-full mt-2 animate-fade-right animate-delay-1000">
                
                    <button
                      className="rounded text-md w-full text-gray-950 py-1 sm:py-2 text-center flex items-center justify-center  bg-gradient-to-r from-gray-200 to-gray-400 animate-rotate-x animate once shadow border-t border-t-gray-100 border-b-2 border-b-gray-500 "
                      onClick={() => removeItem(product.id)}
                    >
                      <MdOutlineRemoveShoppingCart />
                    </button>
                 
                </div>
              </div>
            </div>
            );
          }
          return null;
        })}
      </div>
    </>
  );
};

export default CartPage;
